import React from 'react';
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  Chip,
  IconButton,
  Collapse,
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  Comment as CommentIcon,
} from '@mui/icons-material';
import { getExecutionStatusInfo } from '../../utils/executionUtils';
import ExecutionDetails from './ExecutionDetails';
import PropTypes from 'prop-types';

/**
 * ExecutionTableRow Component
 * Table row for an execution with expandable details
 */
const ExecutionTableRow = ({
  execution,
  isExpanded,
  hasFeedback,
  onToggleExpansion,
  onViewDetails,
  feedback,
}) => {
  const statusInfo = getExecutionStatusInfo(execution);

  return (
    <>
      <TableRow
        hover
        onClick={() => onToggleExpansion(execution.id)}
        sx={{ cursor: 'pointer' }}
      >
        <TableCell>
          <Typography variant="body2" fontFamily="monospace">
            {execution.id.slice(-8)}
          </Typography>
        </TableCell>
        <TableCell>
          <Chip
            label={statusInfo.label}
            color={statusInfo.color}
            size="small"
          />
        </TableCell>
        <TableCell>{new Date(execution.created_at).toLocaleString()}</TableCell>
        <TableCell>{execution.execution_time?.toFixed(2) || 'N/A'}s</TableCell>
        <TableCell>{execution.model_used || 'N/A'}</TableCell>
        <TableCell>{execution.provider_used || 'N/A'}</TableCell>
        <TableCell>
          {execution.cost ? `$${execution.cost.toFixed(4)}` : 'N/A'}
        </TableCell>
        <TableCell>
          <Box display="flex" gap={1} alignItems="center">
            {hasFeedback && (
              <Chip
                icon={<CommentIcon />}
                label="Feedback"
                size="small"
                color="primary"
                variant="outlined"
                sx={{ fontSize: '0.7rem', height: '24px' }}
              />
            )}
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                onViewDetails(execution.id);
              }}
              title="View Details"
            >
              <VisibilityIcon />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>

      {/* Expandable Details Row */}
      {isExpanded && (
        <TableRow>
          <TableCell colSpan={8} sx={{ p: 0 }}>
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <ExecutionDetails execution={execution} feedback={feedback} />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

ExecutionTableRow.propTypes = {
  execution: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  hasFeedback: PropTypes.bool.isRequired,
  onToggleExpansion: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired,
  feedback: PropTypes.object,
};

export default ExecutionTableRow;
